import type { CharacterProfile } from './types';

export const characterProfileFallbacks: Record<number, CharacterProfile> = {
  2: {
    name: '林小满', englishName: 'Mia Lin', role: '猎头新人 Researcher', age: 22,
    birthday: '2004年9月6日', zodiac: '处女座', height: '165 cm', hometown: '江苏苏州',
    education: '华东师范大学 · 心理学', occupation: 'HunkTiger 猎头顾问助理',
    quote: '她每天替别人寻找下一站，却连自己能不能通过试用期都不知道。',
    bio: '22岁的猎头新人。敏感、善良、容易相信人，在被拒绝与试用期压力中，逐渐学会把善意变成专业判断。',
    personality: ['对别人情绪极其敏感', '害怕给别人添麻烦', '别人稍微对她好一点，就会认真记很久', '心里常往坏处想，但第二天仍会准时上班', '不是看不见坏，而是不愿太早把别人想坏'],
    talents: ['会记住简历上没有写的事情', '能听出候选人语言中的停顿和回避', '天然让人愿意说出真实顾虑'],
    weaknesses: ['怕冒犯候选人，不敢追问关键风险', '容易把工作结果和自我价值绑在一起', '把口头信任误当成已经落实'],
    habits: ['紧张时会反复确认手机静音', '重要电话前先整理桌面', '随身带一支黑色签字笔'],
  },
  3: {
    name: '周明远', englishName: 'Michael Zhou', role: '集团董事长 / 客户决策人', age: 56,
    birthday: '1970年1月18日', zodiac: '摩羯座', height: '178 cm', hometown: '浙江宁波',
    education: '复旦大学 · 企业管理', occupation: '启衡集团董事长',
    quote: '他从不提高音量，但会议室里的每个人都会等他说完。',
    bio: '传统制造集团的第二代掌舵人。极度克制、重视兑现，对组织变化有敏锐判断；表面只谈结果，实际上会暗中观察一个人如何承担代价。',
    personality: ['情绪从不写在脸上', '不接受没有数字的判断', '对失信零容忍', '习惯在沉默中观察对方', '真正认可的人会得到长期信任'],
    talents: ['能快速识别组织里的真实权力关系', '擅长在复杂利益中找到平衡点', '记得每一个关键承诺'],
    weaknesses: ['过度依赖个人经验', '很难公开承认判断失误', '对年轻人的耐心有限'],
    habits: ['开会前把手机反扣在桌面', '只用黑色钢笔签字', '做决定前会看向窗外三秒'],
  },
};
